/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询老师/学生认证信息接口
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.CollegeStudentCertificationRes;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/college-student-certification`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
